import { DateTime } from 'luxon'

export function getInvStateColor(state) {
  switch (state) {
    case 'none':
    case 'gen':
      return 'success'
    case 'safety-check':
    case 'low-light':
    case 'sleep':
    case 'idle':
      return 'info'
    case 'fault':
    case 'no-contact':
    case 'locked':
    case 'fault-locked':
      return 'danger'
    default:
      return 'secondary'
  }
}

// ******  Dates/Times

export function dateFromDuration(dur) {
  let now = DateTime.local()
  switch (dur.id) {
    case '3day':
      return [now.minus({ days: 3 }).toISODate(), dateNow()]
    case '7day':
      return [now.minus({ days: 7 }).toISODate(), dateNow()]
    case '1mon':
      return [now.minus({ months: 1 }).toISODate(), dateNow()]
    case '3mon':
      return [now.minus({ months: 3 }).toISODate(), dateNow()]
    case 'range':
      if (dur.text.length !== 24) {
        console.log('ERROR IN dateFromDuration - invalid range:', dur)
      }
      return [dur.text.substr(0, 10), dur.text.substr(14)]
    default:
      console.log('ERROR in dateFromDuration:', dur)
      return [now.minus({ days: 5 }).toISODate(), dateNow()]
  }
}

export function dateNow() {
  return DateTime.local()
}

export function hoursAgo(dat) {
  if (!dat) {
    return 0
  }
  let now = DateTime.local()
  let other = DateTime.fromISO(dat)
  return now.diff(other, 'hours').hours
}

export function diffMins(date1, date2) {
  if (!date1 || !date2) {
    return 0
  }

  let ddate1 = DateTime.fromISO(date1)
  let ddate2 = DateTime.fromISO(date2)
  return Math.abs(ddate1.diff(ddate2, 'minutes').minutes)
}

// ******  Formatting

export function formatPower(power) {
  if (!power || power <= 1) {
    return '--'
  }
  if (power > 1000000) {
    // return Number(power / 1000000).toFixed(1).toLocaleString() + ' MW'
    return formatNum(power / 1000000, 1) + ' MW'
  }
  if (power > 1000) {
    if (power < 10) {
      return formatNum(power / 1000, 1) + ' kW'
    } else {
      return formatNum(power / 1000, 0) + ' kW'
    }
  }
  return power + ' W'
  // return Math.floor(power / 1000).toLocaleString() + ' kW'
}

export function formatNum(val, decimals) {
  if (isNaN(val)) {
    return '-'
  }
  // adds thousands separators and specific number of decimal places
  return Number(val).toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })
}
export function formatVolts(volts) {
  return formatNum(volts, 1)
}

export function formatWatts(watts) {
  return formatNum(watts, 1)
}

export function formatAmps(amps) {
  return formatNum(amps, 2)
}

export function formatInt(val) {
  return formatNum(val, 0)
}

export function formatTemp(temp) {
  if (isNaN(temp)) {
    return '-'
  }
  return formatNum(temp, 1) + ' C'
}

export function formatPct(val) {
  if (isNaN(val)) {
    return '-'
  }
  return formatNum(val, 1) + '%'
}

export function formatGwTime(val, split = false) {
  // TODO - pass site TZ to format in that TZ
  if (!val) {
    return 'Over 6 months'
  }
  let resp = DateTime.fromISO(val).toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS)

  if (split) {
    return resp.replace(', ', '<br>')
  }
  resp = resp.replace(' AM', '&nbsp;AM').replace(' PM', '&nbsp;PM') // to keep it from breaking here
  return resp
}

export function formatDate(val) {
  // TODO tz
  if (!val) {
    return ''
  }
  return DateTime.fromISO(val).toLocaleString(DateTime.DATESHORT)
}

export function prettyPaidThruDate(val) {
  // TODO - make this a component
  const color = DateTime.fromISO(val) >= DateTime.now() ? 'black' : 'red'

  const dateStr = val ? formatDate(val) : '---'
  return `<span style="color:${color}">${dateStr}</span>`
}

export function formatFlags(val) {
  if (!val && val !== 0) {
    return ''
  }
  return '0x' + ('00000000' + Number(val).toString(16)).substr(-8)
}

export function zeroPad(val, size) {
  val = val.toString()
  while (val.length < size) val = '0' + val
  return val
}
